export const cssBundleHref = "/build/css-bundle-H4CHCWTB.css";